import { ref } from 'vue';
import { router } from '@inertiajs/vue3';

export const currentRoute = ref(null);
export const previousRoute = ref(null);

export const startNavigationTracker = () => router.on('navigate', (event) => {
  previousRoute.value = currentRoute.value
  currentRoute.value = event.detail.page.url
});
